import { render, staticRenderFns } from "./clientList.vue?vue&type=template&id=1a4bda94&scoped=true"
import script from "./clientList.vue?vue&type=script&lang=js"
export * from "./clientList.vue?vue&type=script&lang=js"
import style0 from "./clientList.vue?vue&type=style&index=0&id=1a4bda94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bda94",
  null
  
)

export default component.exports